package com.example.mystybag.core.expected

import androidx.compose.runtime.Composable

/**
 * On Web, `true` when the viewport is portrait (`width < height`), i.e. use the same layouts as Android/iOS.
 * On native targets, always `false` (those platforms are not Web).
 */
@Composable
expect fun rememberIsWebPortraitLayout(): Boolean

/**
 * `true` when the UI should use native-style screens instead of Web-only layouts.
 * On Web, follows [rememberIsWebPortraitLayout]; on Android/iOS, always `true` because [PlatformHelper.isWeb] is false.
 */
@Composable
fun rememberUseNativeStyleWebLayout(): Boolean =
    !PlatformHelper.isWeb || rememberIsWebPortraitLayout()

/**
 * `true` only for the wide Web (desktop) layout: on Web AND landscape/wide viewport.
 * On Android/iOS always `false`, and on Web in portrait (phone) also `false`, so screens
 * fall back to their native-style mobile layout. Use this to gate desktop-only chrome such
 * as fixed-width centered columns (`width(1080.dp)` / `width(530.dp)`), `ClientWebHeaderBar`,
 * multi-column grids, etc. — instead of a bare `PlatformHelper.isWeb` check.
 */
@Composable
fun rememberIsWebDesktopLayout(): Boolean = !rememberUseNativeStyleWebLayout()
